<template>
    <b-container fluid >
        <b-row class="my-4">
            <b-col cols="12">
                <h1 class="text-center">Adverts</h1>
            </b-col>
            <b-col cols="12" class="flex-center">
                <b-button variant="primary" @click="createAdvert">New advert</b-button>
            </b-col>
        </b-row>
        <b-row v-if="adverts">
            <b-tabs class="adverts-tab w-100" v-model="currentIndex" @input="currentPage = 1;">
                <b-tab v-for="(advertType, key) in adverts" :key="key" :title="key">
                    <b-row>
                        <b-col v-for="advert in advertsSplice(advertType)"
                               :key="advert.name"
                               cols="12" lg="6" xl="3"
                               class="d-flex flex-column flex-center my-4">
                            <div class="d-flex advert-card"
                                    bg-variant="dark"
                                    text-variant="white"
                                    @click="goToAdvert(advert.id)">
                                <div class="advert-src">
                                    <video v-if="advert.type.id === 4"
                                           :src="advertPath + advert.file_path"
                                           autoplay
                                           muted
                                           loop>
                                    </video>
                                    <b-img v-else :src="advertPath + advert.file_path"></b-img>
                                </div>
                            </div>
                            <div class="text-center my-4">{{advert.name}}</div>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-col cols="12" class="my-2">
                    <b-pagination size="md" align="center" :total-rows="adverts[currentType].length" v-model="currentPage" :per-page="perPage">
                    </b-pagination>
                </b-col>
            </b-tabs>

        </b-row>
    </b-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Adverts',
        data() {
            return {
                adverts: null,
                currentPage: 1,
                currentIndex: 1,
                perPage: 4
            }
        },
        computed: {
            advertPath() {
                return api.advertsPath;
            },
            currentType() {
                let keys = Object.keys(this.adverts);
                return keys[this.currentIndex]
            }
        },
        methods: {
            goToAdvert(id) {
                this.$router.push("/adverts/" + id)
            },
            createAdvert() {
                this.$router.push("/adverts/create")
            },
            advertsSplice(adverts) {
                return adverts.slice((this.currentPage-1) * this.perPage, this.currentPage * this.perPage);
            },
            getAdverts() {
                adamApi.get(api.adverts).then(response => {
                    if (response.status === 200) {
                        this.adverts = response.data;
                    }
                })
            }
        },
        created() {
            this.getAdverts();
        }
    }
</script>

<style lang="scss">
    .adverts-tab {
        .nav-link {
            text-transform: capitalize;
        }
        a {
            color: $bb-purple-light !important;
        }
    }

    .advert-card {
        transition: all .1s ease-in-out;
        overflow: hidden;
        border: 1px solid $bb-purple;
        height: 200px;
        width: 200px;
        border-radius: 10px;
        .card-header {
            padding: 0;
        }
        .advert-src {
            video {
                height: 100%;
            }
        }
        &:hover {
            cursor: pointer;
            transform: scale(1.05);
        }
    }

    .b-pagination {
        .page-link, .page-item.disabled{
            border-color: $bb-purple-light !important;
            background: $bb-purple-light !important;
            color: $bb-purple !important;
        }
        .page-item.active .page-link {
            color: white !important;
        }
    }
</style>
